<template>
  <div class="w-full xl:w-11/12 mx-auto px-3 pb-12 mt-12">
    <h2 class="text-4xl font-semibold text-center">Sponsor a Show</h2>
    <p class="md:text-lg text-gray-800 mb-6  text-center">Want to collect sponsorships for your show? Send an email to Josh@showman.app and let me know.</p>
    <div class="flex flex-wrap justify-center ">
      <event-card v-for="s in sponsorableShows" :key="s.name" :event="s" class="m-3 border sm:border-none w-full"></event-card>
    </div>
  </div>
</template>

<script>

import EventCard from '@/components/EventCard.vue'
export default {
  components: {
    EventCard
  },
  data () {
    return {
      sponsorableEventIds: []
    }
  },
  created () {
    this.fetchSponsorableShowIds()
  },
  computed: {
    upcomingEvents () {
      return this.$store.state.upcomingEvents || []
    },
    sponsorableShows () {
      return this.upcomingEvents.filter(e => this.sponsorableEventIds.includes(e.event_id))
    }
  },
  methods: {
    fetchSponsorableShowIds () {
      this.axios.get(process.env.VUE_APP_ROOT_API + '/getSponsorableEventIds')
        .then(response => {
          this.sponsorableEventIds = response.data.event_ids || []
        })
    }
  }

}
</script>
